import React, { Component } from 'react';
import { Utils } from '../../utils/Utils';
import CountdownTimer from './CountdownTimer';
import { ReplayAction } from './ReplayActionBuilder';

window.actionID;

/**
 * cid=1_1_1&page=9
 */

let rangeSize = 40; //触感容错大小，越大划线越容易
let dotSize = 20;   //触感点的直径
let drawingDotTotal = 0;    //当前笔画正在画的总数

class WriteLetter extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            dotTotal: 0,   //点总数
            pathTotal: 0,   //笔画总数
            curPath: 0, //当前画第几笔，和key相同0是第一笔
            touchArr: [],  //用于存放划过点的数组
            badTouchArr: [], //画错点的集合
            currStarCount: 0,   //当前的星星数
            currSubjectCount: 0,    //当前题目数（有starSubject=1的时候就加1）,
            mainSize: { //显示区的宽高
                width: 690,
                height: 518
            },
        };
        this.cid = Utils.getHashQueryString("cid");
        this.putaoid = Utils.getCookie('putaoid') || 0;
        this.token = Utils.getCookie('token');
        this.uuid = Utils.getCookie('uuid') || 0;
        this.letter = props.item.detail.letters[0];
        this.hasRenderTime = false; //修复字母是一笔的时候，倒着划，倒计时组件重新渲染的问题
        this.replayKeyNum = 2;  //录屏的key，默认有一个 begin和feedback，因此默认是2，每次调用一下ReplayAction.add，就加1
        this.startMoveTime = 0; //用于记录录屏开始画的时间点
        this.linepoints = []; //用于记录录屏画的点的位置
        this.roundNum = 1;  // 第几轮
        this.startWorkTime = new Date().getTime();  // 开始时间，用来计算完成这个模板使用的时间，用于算给积分
        this.isOver = false;    // 是否已完成
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            currStarCount: nextProps.currStarCount,
            currSubjectCount: nextProps.currSubjectCount,
        })
    }

    componentDidMount() {
        const that = this;
        const { isReview } = this.props;
        let dotNum = 0;
        let pathNum = 0;
        fetch(window.resourceUrl + that.letter.pointsID).then((res) => {
            if (res.ok) {
                res.json().then((data) => {
                    for (let i = 0; i < data.length; i++) {
                        pathNum++;
                        for (let j = 0; j < data[i].length; j++) {
                            dotNum++;
                        }
                    }
                    that.setState({
                        data: data,
                        dotTotal: dotNum,
                        pathTotal: pathNum
                    }, () => {
                        if (isReview) {
                            window.dotDatas = data;
                        }
                        //录屏相关代码
                        if (window.needRecoRecordCourse) {
                            if (!(window.g_currentScene && window.g_currentScene.timeline)) {
                                ReplayAction.setScene(JSON.stringify(window.curPageSceneList));
                            }
                            ReplayAction.add(window.keyStr, 'LETTER_REPLAY_BEGIN', (new Date().getTime() - window.recordPageTime), JSON.stringify({
                                "count": 60
                            }));
                        }
                    });
                });
            } else {
                console.log("get letter data fail", res.status);
            }
        }, (e) => {
            console.log("Fetch failed!", e);
        });

        let content_size = {};
        let content_course = document.getElementById('content_course');
        content_size.width = content_course.clientWidth;
        content_size.height = content_course.clientHeight;
        this.setState({
            mainSize: content_size
        });
        that.hasRenderTime = true;
        that.startWorkTime = new Date().getTime();
    }

    handleMousedown() {
        const that = this;
        document.onmousedown = this.mouseMoveDot.bind(this);
        /*定义鼠标移动事件*/
        document.onmousemove = this.mouseMoveDot.bind(this);
        /*定义鼠标抬起事件*/
        document.onmouseup = this.mouseDotUp.bind(this);

        that.startMoveTime = new Date().getTime();
    }

    mouseMoveDot(e) {
        const that = this;

        /*事件兼容*/
        const event = e || window.event;

        const wrap = document.getElementById('wrap_' + that.letter.pointsID); //点是相对字母左上角定位，因此计算的时候要减去字母离屏幕左侧的距离
        if (wrap && !that.isOver) {
            const start_top = Utils.getElementOffsetTop(wrap);
            const start_left = Utils.getElementOffsetLeft(wrap);

            this.compareDot(event.pageX - start_left, event.pageY - start_top);
        }
    }

    compareDot(x, y) {
        let that = this;
        let { data, touchArr, curPath, badTouchArr, mainSize } = this.state;
        let newTouchArr = touchArr;
        let newBadTouchArr = badTouchArr;
        for (let i = 0; i < data.length; i++) { //i 第几划
            for (let j = 0; j < data[i].length; j++) { //j 第几个点
                let item = data[i][j];
                if (Math.abs(x - item.x * that.letter.size.width / 2 * window.mainSize.percent) < rangeSize && Math.abs(y - item.y * that.letter.size.height / 2 * window.mainSize.percent) < rangeSize) {
                    //console.log(i + '_' + j)
                    if (!touchArr.includes(i + '' + j)) {
                        that.refs['dot' + i + '_' + j].style.backgroundColor = '#ffe85f';
                        if (i === curPath) {    //保证当前点在同一笔画
                            drawingDotTotal++;
                            newTouchArr.push(i + '' + j);
                            that.setState({
                                touchArr: [].concat(newTouchArr)
                            });
                        } else if (i < curPath) {
                            //降低难度，当划过的笔画再次划，忽略，视为已划过
                        } else {
                            if (!newBadTouchArr.includes(i + '_' + j)) {
                                newBadTouchArr.push(i + '_' + j);
                                that.setState({
                                    badTouchArr: [].concat(newBadTouchArr)
                                });
                            }
                            //drawingDotTotal = 0;
                        }

                        //录屏相关代码
                        if (window.needRecoRecordCourse) {
                            let _x = ((that.refs['dot' + i + '_' + j].offsetLeft + dotSize / 2) / mainSize.width);
                            let _y = ((that.refs['dot' + i + '_' + j].offsetTop + dotSize / 2) / mainSize.height);
                            let canPush = true;
                            if (that.linepoints && that.linepoints.length) {
                                for (let k = 0; k < that.linepoints.length; k++) {
                                    let linepoint = that.linepoints[k];
                                    if (linepoint.x === _x && linepoint.y === _y) {
                                        canPush = false;
                                    }
                                }
                            }
                            if (canPush) {
                                that.linepoints.push({ "x": _x, "y": _y });
                            }
                        }
                    }
                }
            }
        }
    }

    mouseDotUp(e) {
        document.onmousemove = null;
        document.onmouseup = null;
        const that = this;
        const { item } = this.props;
        let { data, touchArr, dotTotal, pathTotal, curPath, badTouchArr } = this.state;
        for (let i = 0; i < touchArr.length; i++) {
            if (i > 0) {    //第一个点没办法和前面进行对比，因此忽略第一个点
                if (touchArr[0].substr(1, 1) !== '0' ||   //不是从第一个点开始画  //e.target.dataset.id !== '0' ||
                    ((touchArr[i] - touchArr[i - 1] !== 1)    //后面一个点没有紧跟前面的点
                        && touchArr[i].substr(0, 1) === touchArr[i - 1].substr(0, 1)) ||    //保证是在一个笔画
                    drawingDotTotal === 0 ||    //当划的点数被设为0
                    drawingDotTotal < data[curPath].length  //当前画的点数小于这个笔画应该有的点数，重设
                ) {
                    that.resetDots(curPath);
                } else {
                    if (curPath < pathTotal) {
                        that.setState({
                            curPath: curPath + 1
                        });
                    }
                }
            }
        }
        //去掉多余的点
        if (badTouchArr && badTouchArr.length) {
            for (let i = 0; i < badTouchArr.length; i++) {
                that.refs['dot' + badTouchArr[i]].style.backgroundColor = '#fff';
            }
            that.setState({
                badTouchArr: []
            });
        }

        //没有把一笔画完
        if (data[curPath] && data[curPath].length !== drawingDotTotal) {
            that.resetDots(curPath);
        }

        //录屏相关代码
        if (window.needRecoRecordCourse) {
            ReplayAction.add(window.keyStr, 'LETTER_REPLAY_DRAWLINE', (that.startMoveTime - window.recordPageTime), JSON.stringify({
                linepoints: that.linepoints
            }));
            that.linepoints = [];
            that.replayKeyNum++;
        }

        //画完回调
        if (touchArr.length === dotTotal && drawingDotTotal !== 0 && !that.isOver) {
            that.handleComplate(item.detail.feedbacks.succ);
        }

        drawingDotTotal = 0;

    }

    //兼容触屏版
    touchMoveDot(e) {
        const that = this;
        let wrap = document.getElementById('wrap_' + that.letter.pointsID).getBoundingClientRect(); //点是相对字母左上角定位，因此计算的时候要减去字母离屏幕左侧的距离
        this.compareDot(e.touches[0].pageX - wrap.left, e.touches[0].pageY - wrap.top);
        that.startMoveTime = that.startMoveTime ? that.startMoveTime : new Date().getTime();
    }

    resetDots(curDrag) {
        let that = this;
        //线画错了重置点的颜色，置空touchArr
        // console.log('curDrag:', curDrag)
        let { touchArr, pathTotal, curPath } = this.state;
        let newTouchArr = [];
        if (curPath < pathTotal) {
            let dots = document.getElementById('drag_' + curDrag).getElementsByClassName('dot' + that.letter.poontsID);
            for (let i = 0; i < dots.length; i++) {
                dots[i].style.backgroundColor = '#fff'
            }
            for (let i = 0; i < touchArr.length; i++) {
                let _path = parseInt(touchArr[i].substr(0, 1), 10);
                if (_path !== curPath) {
                    newTouchArr.push(touchArr[i]);
                }
            }
            this.setState({
                touchArr: [].concat(newTouchArr),
                curPath: curDrag
            });
            drawingDotTotal = 0;
        }
    }

    handleComplate(feedback) {
        const that = this;
        const { item, childCallback, isReview } = this.props;
        const { currStarCount, currSubjectCount } = this.state;
        const judgeFunction = item.detail.judgeFunction;
        const timeout = item.detail && item.detail.feedbacks && item.detail.feedbacks.timeout ? item.detail.feedbacks.timeout : null;
        let type = "";
        let info = "";
        that.isOver = true;
        if (!isReview) {
            if (feedback) {
                if (feedback.type) {
                    type = feedback.type;
                }
                if (feedback.info) {
                    info = feedback.info;
                }
            } else {
                type = timeout ? timeout.type : "";
                info = timeout ? timeout.info : "";
            }
            if (judgeFunction) {
                let returnScore = JSON.parse(window[judgeFunction](//actionID, type, info, currStarCount, currSubjectCount
                    item.actionID,
                    type,
                    info,
                    currStarCount,
                    currSubjectCount,
                ));
                if (returnScore && returnScore.resultInfo && returnScore.timeline) {
                    if (typeof childCallback === 'function') {
                        //录屏相关代码
                        if (window.needRecoRecordCourse) {
                            ReplayAction.add(window.keyStr, 'LETTER_REPLAY_FEEDBACK', (new Date().getTime() - window.recordPageTime), JSON.stringify(returnScore));
                            ReplayAction.commit(window.keyStr, 'FacsimileGameInteraction_');
                            window.keyStr += `.detail.timeline.nodes[${that.replayKeyNum}].actions[0]`;

                            childCallback(returnScore, ReplayAction.getScene());

                            ReplayAction.cleanScene();
                        } else {
                            childCallback(returnScore);
                        }
                    }
                }
            }

            that.hasRenderTime = false;

            //上报学习报告
            if (that.cid) {
                // Utils.reportRecord(window.startTime, item.actionID, item.actionType, type, 0, item.knowledge);
                if (item.actionID === window.actionID) {
                    that.roundNum++;
                } else {
                    that.roundNum = 1;
                }
                window.actionID = item.actionID;
                Utils.newReportRecord({
                    "putaoid": that.putaoid,
                    "token": that.token,
                    "cid": that.cid,
                    "startTime": window.startTime,
                    "actionId": item.actionID,
                    "actionType": item.actionType,
                    "fbType": type,   //fbType,
                    "roundNum": that.roundNum,  //轮数（第几轮回答，默认第一轮：1）
                    "score": 0,
                    "from": "pc",
                    "pageNum": window.curPageToReport || 0,
                }, {
                    "knowledge": item.knowledge
                });

                // 给积分
                Utils.giveIntegrals(2, {
                    totalTime: timeout ? timeout.time : 60,
                    useTime: (new Date().getTime() - that.startWorkTime) / 1000,
                    roundNum: that.roundNum,
                    fbType: type
                });

                // 勋章上报
                Utils.encourageRecord({
                    "putaoid": that.putaoid,
                    "token": that.token,
                    "cid": that.cid,
                    "startTime": window.startTime,
                    "actionId": item.actionID,
                    "actionType": item.actionType,
                    "fbType": type,   //fbType,
                    "roundNum": that.roundNum,  //轮数（第几轮回答，默认第一轮：1）
                    "score": 0,
                    "from": "pc",
                    "pageNum": window.curPageToReport || 0,
                    "integrals": window.curIntegrals,
                });
            }
        }
    }

    render() {
        const that = this;
        const { item } = this.props;
        const { data } = this.state;
        return (
            <div style={{
                "position": "absolute",
                "left": 0,
                "top": 0,
                "width": '100%',
                "height": '100%'
            }}
                onMouseDown={(e) => that.handleMousedown(e)}
                onTouchStart={(e) => that.touchMoveDot(e)}  //兼容一笔是一个点 cid=1_5_1&page=10
                onTouchMove={(e) => that.touchMoveDot(e)}
                onTouchEnd={(e) => that.mouseDotUp(e)}
            // onMouseMove={(e) => that.mouseMoveDot(e)}
            // onMouseUp={(e) => that.mouseDotUp(e)}
            >
                {
                    that.hasRenderTime && item.detail.feedbacks ?
                        <CountdownTimer feedbacks={item.detail.feedbacks} complateCallback={that.handleComplate.bind(that)} />
                        : null
                }
                <div style={{
                    "position": "absolute",
                    "left": that.letter.pos.x * 100 + '%',
                    "top": that.letter.pos.y * 100 + '%',
                    "width": that.letter.size.width / 2 * window.mainSize.percent + 'px',
                    "height": that.letter.size.height / 2 * window.mainSize.percent + 'px',
                    // "backgroundImage": "url('" + window.resourceUrl + that.letter.imageID + "')",
                    "backgroundSize": "cover"
                }} />
                <div id={"wrap_" + that.letter.pointsID} style={{
                    "position": "absolute",
                    "left": that.letter.pos.x * 100 + '%',
                    "top": that.letter.pos.y * 100 + '%',
                    "width": that.letter.size.width / 2 * window.mainSize.percent + 'px',
                    "height": that.letter.size.height / 2 * window.mainSize.percent + 'px',
                    // "backgroundImage": "url(" + window.resourceUrl + that.letter.maskViewID + ")",
                    "backgroundSize": "cover"
                }}>
                    {
                        data && data.map((item, index) => {
                            return (
                                <div id={"drag_" + index} key={index} style={{
                                    "position": "absolute",
                                    "width": that.letter.size.width / 2 * window.mainSize.percent + 'px',
                                    "height": that.letter.size.height / 2 * window.mainSize.percent + 'px',
                                    "cursor": "pointer"
                                }}>
                                    {
                                        item.map((item1, index1) => {
                                            return (
                                                <div ref={"dot" + index + '_' + index1} data-id={index1}
                                                    className={"dot" + item.resourceID}
                                                    key={index1}
                                                    style={{
                                                        "width": dotSize * window.mainSize.percent + 'px',
                                                        "height": dotSize * window.mainSize.percent + 'px',
                                                        "borderRadius": dotSize + 'px',
                                                        "marginTop": -dotSize / 2 + 'px',
                                                        "marginLeft": -dotSize / 2 + 'px',
                                                        "position": "absolute",
                                                        "left": item1.x * 100 + '%',
                                                        "top": item1.y * 100 + '%',
                                                        "background": "#fff"
                                                    }} />
                                            )
                                        })
                                    }
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        );
    }
}

export default WriteLetter;



// WEBPACK FOOTER //
// ./src/components/on/WriteLetter.js